module.exports = __webpack_public_path__ + "img/30.218aeff1.jpg";